/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ProjectPagesType from '@jira/spa-apps__project-pages/src/ProjectPages.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { RedirectToProjectType } from './project-type/index.tsx';

/* oxlint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyProjectPages: LazyComponent<React.ComponentType<Record<any, any>>> = lazyForPaint<
	typeof ProjectPagesType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-pages", jiraSpaEntry: "async-project-pages" */ '@jira/spa-apps__project-pages/src/ProjectPages.tsx'
			),
		),
	{ ssr: false },
);
/* oxlint-enable @typescript-eslint/no-explicit-any */

export const PagesRedirect = (): React.JSX.Element => <RedirectToProjectType page="/pages" />;

const AsyncProjectPages = (): React.JSX.Element => (
	<LazyPage Page={LazyProjectPages} pageId="project-pages" shouldShowSpinner={false} />
);

export default AsyncProjectPages;
